var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPortfolio105 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 105,
  height: 105,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9 26.5c0-1.934 1.566-3.5 3.5-3.5h80c1.934 0 3.5 1.566 3.5 3.5V66H62.5a.5.5 0 0 0 0 1h34a.5.5 0 0 0 .5-.5v-40c0-2.486-2.014-4.5-4.5-4.5h-80A4.499 4.499 0 0 0 8 26.5v40a.5.5 0 0 0 .5.5h34a.5.5 0 0 0 0-1H9V26.5Zm4 50a.5.5 0 0 0-1 0v14c0 2.486 2.014 4.5 4.5 4.5h72c2.486 0 4.5-2.014 4.5-4.5v-14a.5.5 0 0 0-1 0v14c0 1.934-1.566 3.5-3.5 3.5h-72a3.499 3.499 0 0 1-3.5-3.5v-14Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-decorative-coral)",
  fillRule: "evenodd",
  d: "M38.5 10a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 1 0V11h27v11.5a.5.5 0 0 0 1 0v-12a.5.5 0 0 0-.5-.5h-28Zm4 48a.5.5 0 0 0-.5.5v16a.5.5 0 0 0 .5.5h20a.5.5 0 0 0 .5-.5v-16a.5.5 0 0 0-.5-.5h-20Zm.5 16V59h19v15H43Z",
  clipRule: "evenodd"
})));
export { SvgPortfolio105 as ReactComponent };
export default __webpack_public_path__ + "e53d1cd225367b1ebf3118eb0d2ec3b8.svg";